import React from 'react'
import Img from 'gatsby-image'

const GatsbyImage = props => <Img {...props}/>

export const QueriedGatsbyImage = ({image, ...rest}) => {
	if (!image) return null

	if (image.extension === 'svg') return <img alt='' {...rest} src={image.publicURL}/>

	if (!image.childImageSharp) return null
	const {childImageSharp} = image

	if (childImageSharp.fluid) return <GatsbyImage  {...rest} fluid={childImageSharp.fluid}/>
	if (childImageSharp.fixed) return <GatsbyImage {...rest} fixed={childImageSharp.fixed}/>
}
export default GatsbyImage

